import { Account } from "../types";
import HDFC from '../assets/icons/HDFC.svg';
import ICICI from '../assets/icons/ICICI.svg';
import BOI from '../assets/icons/BOI.svg';
import FederalBank from '../assets/icons/FederalBank.svg';
import Amex from '../assets/icons/Amex.svg';
import KotakMahindraBank from '../assets/icons/KotakMahindraBank.svg';
import AxisBank from '../assets/icons/AxisBank.svg';
import { FiCreditCard } from 'react-icons/fi';

interface AccountIconProps {
  account: Account;
  className?: string;
  showFallback?: boolean;
  fallbackIconClassName?: string;
}

const getIconForAccount = (accountName: string) => {
  const normalizedName = accountName.trim().toLowerCase();

  if (normalizedName.includes('hdfc')) {
    return { src: HDFC, alt: 'HDFC' };
  }

  if (normalizedName.includes('icici')) {
    return { src: ICICI, alt: 'ICICI' };
  }

  if (normalizedName === 'boi' || normalizedName.includes('bank of india')) {
    return { src: BOI, alt: 'BOI' };
  }

  if (normalizedName.includes('onecard') || normalizedName.includes('federal')) {
    return { src: FederalBank, alt: 'Federal Bank' };
  }

  if (normalizedName.includes('amex') || normalizedName.includes('american express')) {
    return { src: Amex, alt: 'Amex' };
  }

  if (normalizedName.includes('kotak')) {
    return { src: KotakMahindraBank, alt: 'Kotak Mahindra Bank' };
  }

  if (normalizedName.includes('axis')) {
    return { src: AxisBank, alt: 'Axis Bank' };
  }

  return null;
};

const AccountIcon = ({
  account,
  className,
  showFallback = false,
  fallbackIconClassName,
}: AccountIconProps) => {
  const icon = getIconForAccount(account.name);

  return (
    <div className={`flex items-center justify-center pointer-events-none ${className}`} title={`Account ID: ${account.id}`}>
      {icon && <img src={icon.src} alt={`${icon.alt} logo`} className="w-full h-full object-contain" />}
      {!icon && showFallback && <FiCreditCard className={fallbackIconClassName || 'text-muted-foreground'} size={16} />}
    </div>
  );
};

export default AccountIcon;
